<template>
  <div class="site-shell">
    <Navigation />
    <main class="site-main">
      <router-view />
    </main>

    <footer class="site-footer">
      <div class="footer-inner">
        <img
          src="./assets/JORGE-CASTANHO-LDA-LOGOTIPO-TRANSP.png"
          :alt="t('app.logoAlt')"
          class="footer-logo"
        />
        <p>{{ t("footer.description") }}</p>
        <p>
          <a href="tel:+351244024482">+351 244 024 482</a>
          <span class="dot">•</span>
          <a href="mailto:info@jorgecastanho.pt">info@jorgecastanho.pt</a>
        </p>
        <p class="copyright">{{ t("footer.copyright") }}</p>
      </div>
    </footer>
  </div>
</template>

<script>
import Navigation from "./components/Navigation.vue";
import { t } from "./i18n";

export default {
  name: "App",
  components: {
    Navigation,
  },
  methods: {
    t,
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "Montserrat Custom";
  src: url("./assets/fonts/Montserrat-VariableFont_wght.ttf") format("truetype");
  font-weight: 100 900;
  font-style: normal;
  font-display: swap;
}

:root {
  --brand-purple: #5b1c9f;
  --brand-purple-deep: #2f0f57;
  --brand-ink: #0f141c;
  --brand-steel: #c8d0df;
  --brand-smoke: #f3f5f9;
  --brand-white: #ffffff;
  --content-max: 1200px;
  --ease: 260ms ease;
}

* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
}

body {
  font-family: "Montserrat Custom", "Segoe UI", sans-serif;
  color: var(--brand-ink);
  background:
    radial-gradient(circle at 20% -10%, rgba(91, 28, 159, 0.18), transparent 36%),
    radial-gradient(circle at 100% 10%, rgba(15, 20, 28, 0.12), transparent 28%),
    linear-gradient(160deg, #f8f9fc 0%, #eff2f8 100%);
}

#app {
  min-height: 100vh;
}

a {
  color: inherit;
}

.site-shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.site-main {
  flex: 1;
}

.section-wrap {
  width: min(calc(100% - 2.5rem), var(--content-max));
  margin-inline: auto;
}

.section-title {
  margin: 0;
  font-size: clamp(1.8rem, 4vw, 3.4rem);
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.section-lead {
  margin: 0;
  max-width: 64ch;
  color: #4a5363;
  line-height: 1.7;
}

.site-footer {
  border-top: 1px solid rgba(91, 28, 159, 0.12);
  background: linear-gradient(135deg, #ffffff 0%, #f6f7fb 100%);
}

.footer-inner {
  width: min(calc(100% - 2.5rem), var(--content-max));
  margin-inline: auto;
  padding: 2.5rem 0 2.25rem;
  text-align: center;
}

.footer-logo {
  width: min(300px, 80%);
  margin-bottom: 1rem;
}

.footer-inner p {
  margin: 0.5rem 0;
  color: #4a5363;
}

.footer-inner a {
  text-decoration: none;
  color: var(--brand-purple);
  font-weight: 600;
}

.footer-inner .dot {
  margin-inline: 0.5rem;
  color: #8f9ab0;
}

.copyright {
  margin-top: 1rem;
  font-size: 0.88rem;
  color: #7b8498;
}
</style>
